import { getToken } from "./token";

export const authorize = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`, // Set the Authorization header
  },
});